export const getProfileInfoRoutes = {
  GET_PROFILE: "/user", // GET (новый API)
};
